import React from "react"
import { classes } from "@utils"

export const ArticleList = ({ content }) => {
  const { title, list } = content
  const { aC } = classes
  return (
    <div className={`${aC}__body-list`}>
      <h4>{title}</h4>
      <ul>
        {list.map((elem, index) => (
          <li key={index}>
            <div className="circle">
              <span></span>
              </div> 
            <div>{elem}</div>
          </li>
        ))}
      </ul>
    </div>
  )
}
